<template>
  <div v-if="message && message.length > 0" class="pdp-add-to-cart-status">
    <div id="cart-add-success" class="cart-add-success table">
      <div class="cart-add-success__message">
        <i class="md-18">check_circle</i> <span id="cart-add-success-message" v-html="message" />
      </div>
      <p class="cart-add-success__button">
        <a
          :href="isElectraBrand ? `${trekBrandNavURL}/cart?clear=true` : `${trekBrandNavURL}/cart`"
          v-html="bp('viewBasket')"
        />
      </p>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex';

export default {
  name: 'PdpAddToCartStatus',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('backend', ['trekBrandNavURL']),
    ...mapState('pdp', ['isElectraBrand']),
  },
};
</script>
